import React from 'react';
import "./Header.css"

const Header = () => {
    return (
        <div className="header">
            <h2>The Writer Commitie</h2>
            <p>A writer is a person who uses written words in different styles and techniques to communicate ideas. Writers produce different forms of literary art and creative writing such as novels, short stories, books, poetry, travelogues, plays, screenplays, teleplays, songs, and essays as well as other reports and news articles that may be of interest to the public</p>
            <h2>Total Expenses: $100 Million</h2>
        </div>
    );
};

export default Header;